import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import createMutationsSharer from 'vuex-shared-mutations'

Vue.use(Vuex)
export default new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: window.localStorage,
      key: 'AI_SENSOR',
      paths: ['user', 'token', 'isLogin', 'permissions', 'lang', 'routeParam', 'AccessType', 'areaIds']
    }),
    createMutationsSharer({ predicate: ['login'] })
  ],
  state: {
    user: '',
    token: '',
    isLogin: false,
    permissions: [],
    lang: process.env.VUE_APP_MULTILANG_LANG_DEFAULT,
    routeParam: [],
    AccessType: '',
    areaIds: [],
    eventNotify: {
      lastRead: 0,
      events: [],
    },
  },
  getters: {
    getUser: state => {
      return state.user
    },
    getPermissions: state => {
      return state.permissions
    },
    getRouteParam: state => {
      return state.routeParam
    },
    getAccessType: state => {
      return state.AccessType
    },
    eventNotify: state => {
      return state.eventNotify.events
    },
    unreadEventNotify: state => {
      return state.eventNotify.events.filter(item => item.iat > state.eventNotify.lastRead).length
    },
    lastEventNotifyRead: state => {
      return state.eventNotify.lastRead
    }
  },
  actions: {
    newEventNotify({ commit, state }, payload) {
      const event = JSON.parse(payload)

      if (state.areaIds.indexOf(event.areaId) >= 0) {
        commit('newEventNotify', { ...event, iat: new Date().getTime() })
      }

      commit(
        'filterExpEventNotify',
        Math.min(state.eventNotify.lastRead, new Date().getTime() - 2 * 60 * 1000 /* 2 min */)
      )
    },
    eventNotifyRead({ commit }) {
      commit('setEventNotifyRead', new Date().getTime())
    }
  },
  mutations: {
    login (state, user) {
      const _user = JSON.parse(user)
      state.user = user
      state.token = _user.token
      state.areaIds = _user.area_ids
      state.isLogin = true
    },
    logout (state) {
      state.isLogin = false
      state.user = ''
      state.token = ''
      state.permissions = ''
      localStorage.removeItem('sToken')
      localStorage.removeItem('AI_SENSOR')
      // window.localStorage.clear()
    },
    setPermission (state, permissions) {
      state.permissions = permissions
    },
    setLang (state, value) {
      state.lang = value
    },
    setRouteParam (state, rParam) {
      state.routeParam = rParam
    },
    setAccessType (state, value) {
      state.AccessType = value
    },
    newEventNotify (state, payload) {
      state.eventNotify.events.push(payload)
    },
    filterExpEventNotify (state, time) {
      state.eventNotify.events = state.eventNotify.events.filter(item => item.iat > time)
    },
    setEventNotifyRead (state, time) {
      state.eventNotify.lastRead = time
    }
  }
})
